export const environment = {
    production: true,
    env: 'prod',
    baseDomain: 'vizorro.ru',
    urls: {
        app: 'https://app.vizorro.ru',
        api: 'https://api.vizorro.ru',
        auth: 'https://auth.vizorro.ru',
    },
};

export function sendBugReport(_error: any): void {}
